export const APPROVAL_STATE = {
  scpiRequireExpertApproval: 'SCPI_REQUIRE_EXPERT_APPROVAL',
  scpiAwaitingExpertApproval: 'SCPI_AWAITING_EXPERT_APPROVAL',
  expertShouldApproveControl: 'EXPERT_SHOULD_APPROVE_CONTROL',
  expertHasApprovedControl: 'EXPERT_HAS_APPROVED_CONTROL',
  canBeValidated: 'CAN_BE_VALIDATED',
  controlValidated: 'CONTROL_VALIDATED',
} as const;
export type ApprovalState = typeof APPROVAL_STATE[keyof typeof APPROVAL_STATE];
